import InvestorVerify from './InvestorVerify.component';

export default InvestorVerify;
